import { defaultLayouts } from "golfstatus_react_components";

export const slideoutRootStyle = {
  ...defaultLayouts.vStack,
  ...defaultLayouts.fullWidth,
  height: "100%",
};

export const slideoutContentStyle = {
  ...defaultLayouts.vStack,
  ...defaultLayouts.fullWidth,
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
};

export const slideoutPageStyle = { height: "100%", overflow: "hidden" };
